export const classifications = [
  {
    Code: '001',
    label: '001 - Breastfeeding equipment ',
  },
  {
    Code: '002',
    label: '002 - Child care centres and kindergartens fees',
  },
  {
    Code: '003',
    label: '003 - Computer, smartphone or tablet',
  },
  {
    Code: '004',
    label: '004 - Consolidated e-Invoice ',
  },
  {
    Code: '005',
    label:
      '005 - Construction materials (as specified under Fourth Schedule of the Lembaga Pembangunan Industri Pembinaan Malaysia Act 1994)',
  },
  {
    Code: '006',
    label: '006 - Disbursement ',
  },
  {
    Code: '007',
    label: '007 - Donation',
  },
  {
    Code: '008',
    label: '008 - e-Commerce - e-Invoice to buyer / purchaser',
  },
  {
    Code: '009',
    label: '009 - e-Commerce - Self-billed e-Invoice to seller, logistics, etc. ',
  },
  {
    Code: '010',
    label: '010 - Education fees',
  },
  {
    Code: '011',
    label: '011 - Goods on consignment (Consignor)',
  },
  {
    Code: '012',
    label: '012 - Goods on consignment (Consignee)',
  },
  {
    Code: '013',
    label: '013 - Gym membership',
  },
  {
    Code: '014',
    label: '014 - Insurance - Education and medical benefits',
  },
  {
    Code: '015',
    label: '015 - Insurance - Takaful or life insurance',
  },
  {
    Code: '016',
    label: '016 - Interest and financing expenses',
  },
  {
    Code: '017',
    label: '017 - Internet subscription ',
  },
  {
    Code: '018',
    label: '018 - Land and building',
  },
  {
    Code: '019',
    label:
      '019 - Medical examination for learning disabilities and early intervention or rehabilitation treatments of learning disabilities',
  },
  {
    Code: '020',
    label: '020 - Medical examination or vaccination expenses',
  },
  {
    Code: '021',
    label: '021 - Medical expenses for serious diseases',
  },
  {
    Code: '022',
    label: '022 - Others',
  },
  {
    Code: '023',
    label:
      '023 - Petroleum operations (as defined in Petroleum (Income Tax) Act 1967)',
  },
  {
    Code: '024',
    label: '024 - Private retirement scheme or deferred annuity scheme ',
  },
  {
    Code: '025',
    label: '025 - Motor vehicle',
  },
  {
    Code: '026',
    label:
      '026 - Subscription of books / journals / magazines / newspapers / other similar publications',
  },
  {
    Code: '027',
    label: '027 - Reimbursement ',
  },
  {
    Code: '028',
    label: '028 - Rental of motor vehicle',
  },
  {
    Code: '029',
    label:
      '029 - EV charging facilities (Installation, rental, sale / purchase or subscription fees) ',
  },
  {
    Code: '030',
    label: '030 - Repair and maintenance',
  },
  {
    Code: '031',
    label: '031 - Research and development ',
  },
  {
    Code: '032',
    label: '032 - Foreign income ',
  },
  {
    Code: '033',
    label: '033 - Self-billed - Betting and gaming ',
  },
  {
    Code: '034',
    label: '034 - Self-billed - Importation of goods ',
  },
  {
    Code: '035',
    label: '035 - Self-billed - Importation of services',
  },
  {
    Code: '036',
    label: '036 - Self-billed - Others',
  },
  {
    Code: '037',
    label: '037 - Self-billed - Monetary payment to agents, dealers or distributors ',
  },
  {
    Code: '038',
    label:
      '038 - Sports equipment, rental / entry fees for sports facilities, registration in sports competition or sports training fees imposed by associations / sports clubs / companies registered with the Sports Commissioner or Companies Commission of Malaysia and carrying out sports activities as listed under the Sports Development Act 1997',
  },
  {
    Code: '039',
    label: '039 - Supporting equipment for disabled person',
  },
  {
    Code: '040',
    label: '040 - Voluntary contribution to approved provident fund ',
  },
  {
    Code: '041',
    label: '041 - Dental examination or treatment',
  },
  {
    Code: '042',
    label: '042 - Fertility treatment',
  },
  {
    Code: '043',
    label:
      '043 - Treatment and home care nursing, daycare centres and residential care centers',
  },
  {
    Code: '044',
    label: '044 - Vouchers, gift cards, loyalty points, etc',
  },
  {
    Code: '045',
    label:
      '045 - Self-billed - Non-monetary payment to agents, dealers or distributors',
  },
]


// export const classifications = [
//   {
//     Code: '001',
//     label: 'Breastfeeding equipment ',
//   },
//   {
//     Code: '002',
//     label: 'Child care centres and kindergartens fees',
//   },
//   {
//     Code: '003',
//     label: 'Computer, smartphone or tablet',
//   },
//   {
//     Code: '004',
//     label: 'Consolidated e-Invoice ',
//   },
//   {
//     Code: '005',
//     label:
//       'Construction materials (as specified under Fourth Schedule of the Lembaga Pembangunan Industri Pembinaan Malaysia Act 1994)',
//   },
//   {
//     Code: '006',
//     label: 'Disbursement ',
//   },
//   {
//     Code: '007',
//     label: 'Donation',
//   },
//   {
//     Code: '008',
//     label: 'e-Commerce - e-Invoice to buyer / purchaser',
//   },
//   {
//     Code: '009',
//     label: 'e-Commerce - Self-billed e-Invoice to seller, logistics, etc. ',
//   },
//   {
//     Code: '010',
//     label: 'Education fees',
//   },
//   {
//     Code: '011',
//     label: 'Goods on consignment (Consignor)',
//   },
//   {
//     Code: '012',
//     label: 'Goods on consignment (Consignee)',
//   },
//   {
//     Code: '013',
//     label: 'Gym membership',
//   },
//   {
//     Code: '014',
//     label: 'Insurance - Education and medical benefits',
//   },
//   {
//     Code: '015',
//     label: 'Insurance - Takaful or life insurance',
//   },
//   {
//     Code: '016',
//     label: 'Interest and financing expenses',
//   },
//   {
//     Code: '017',
//     label: 'Internet subscription ',
//   },
//   {
//     Code: '018',
//     label: 'Land and building',
//   },
//   {
//     Code: '019',
//     label:
//       'Medical examination for learning disabilities and early intervention or rehabilitation treatments of learning disabilities',
//   },
//   {
//     Code: '020',
//     label: 'Medical examination or vaccination expenses',
//   },
//   {
//     Code: '021',
//     label: 'Medical expenses for serious diseases',
//   },
//   {
//     Code: '022',
//     label: 'Others',
//   },
//   {
//     Code: '023',
//     label:
//       'Petroleum operations (as defined in Petroleum (Income Tax) Act 1967)',
//   },
//   {
//     Code: '024',
//     label: 'Private retirement scheme or deferred annuity scheme ',
//   },
//   {
//     Code: '025',
//     label: 'Motor vehicle',
//   },
//   {
//     Code: '026',
//     label:
//       'Subscription of books / journals / magazines / newspapers / other similar publications',
//   },
//   {
//     Code: '027',
//     label: 'Reimbursement ',
//   },
//   {
//     Code: '028',
//     label: 'Rental of motor vehicle',
//   },
//   {
//     Code: '029',
//     label:
//       'EV charging facilities (Installation, rental, sale / purchase or subscription fees) ',
//   },
//   {
//     Code: '030',
//     label: 'Repair and maintenance',
//   },
//   {
//     Code: '031',
//     label: 'Research and development ',
//   },
//   {
//     Code: '032',
//     label: 'Foreign income ',
//   },
//   {
//     Code: '033',
//     label: 'Self-billed - Betting and gaming ',
//   },
//   {
//     Code: '034',
//     label: 'Self-billed - Importation of goods ',
//   },
//   {
//     Code: '035',
//     label: 'Self-billed - Importation of services',
//   },
//   {
//     Code: '036',
//     label: 'Self-billed - Others',
//   },
//   {
//     Code: '037',
//     label: 'Self-billed - Monetary payment to agents, dealers or distributors ',
//   },
//   {
//     Code: '038',
//     label:
//       'Sports equipment, rental / entry fees for sports facilities, registration in sports competition or sports training fees imposed by associations / sports clubs / companies registered with the Sports Commissioner or Companies Commission of Malaysia and carrying out sports activities as listed under the Sports Development Act 1997',
//   },
//   {
//     Code: '039',
//     label: 'Supporting equipment for disabled person',
//   },
//   {
//     Code: '040',
//     label: 'Voluntary contribution to approved provident fund ',
//   },
//   {
//     Code: '041',
//     label: 'Dental examination or treatment',
//   },
//   {
//     Code: '042',
//     label: 'Fertility treatment',
//   },
//   {
//     Code: '043',
//     label:
//       'Treatment and home care nursing, daycare centres and residential care centers',
//   },
//   {
//     Code: '044',
//     label: 'Vouchers, gift cards, loyalty points, etc',
//   },
//   {
//     Code: '045',
//     label:
//       'Self-billed - Non-monetary payment to agents, dealers or distributors',
//   },
// ]
